import { render, staticRenderFns } from "./avisoprivacidad.vue?vue&type=template&id=3e88efc4&"
import script from "./avisoprivacidad.vue?vue&type=script&lang=js&"
export * from "./avisoprivacidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports